module.exports = __webpack_public_path__ + "assets/img/logo-tablet.7838cdb1.png";